import Vue from 'vue';

/**
 * Returns truncated string based on length. Returns original string if it's shorter than length.
 * @param {string} str
 * @param {number} length
 * @returns {string}
 */
function truncate(str: string, length = 100) {
  return str.length > length ? str.substr(0, length - 1) + '…' : str;
}

Vue.filter('truncate', truncate);
